import { MdCalendarMonth, MdOutlineAccessTime, MdOutlineLocationOn, MdVerifiedUser } from "react-icons/md";
import { stats } from "../ones/RunzeweContent";

const icons = [
  <MdCalendarMonth />,
  <MdOutlineAccessTime />,
  <MdVerifiedUser />,
  <MdOutlineLocationOn />,
];

export default function HomeStatsBand() {
  return (
    <section className="home-stats-section">
      <div className="container">
        <div className="home-stats-band" data-aos="fade-up">
          {stats.map((item, index) => (
            <div className="stat-item" key={item.label} data-aos="fade-up" data-aos-delay={index * 70}>
              <div className="stat-icon">{icons[index]}</div>
              <div>
                <span>{item.label}</span>
                <strong>{item.value}</strong>
                <small>{item.detail}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
